import React, { Component } from "react";
import { Link } from "react-router-dom";

class DemanderMesIdentifiantsForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 1,
      dob: "",
      cin: "",
    };
  }

  // Handle input changes
  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };
  
  handleDobChange = (event) => {
    const dob = event.target.value;
    this.setState({ dob });
  };

  render() {
    return (
      <form action="#!" className="login">
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <label className="sr-only">
                CIN <span className="text-danger  fw-bold">*</span>
              </label>
              <input
                type="text"
                name="cin"
                value={this.state.cin}
                onChange={this.handleInputChange}
                className="form-control"
                placeholder="Entrez votre cin"
              />
            </div>
          </div>

          <div className="col-12">
            <div className="form-group">
              <label className="sr-only">
                Date de Naissance{" "}
                <span className="text-danger  fw-bold">*</span>
              </label>
              <input
                type="date"
                name="dob"
                value={this.state.dob} // Bound to the state
                onChange={this.handleDobChange} // This triggers the handler
                className="form-control cursor-pointer"
                placeholder="DD/MM/YYYY"
              />
            </div>
          </div>
        </div>

        {/* Navigation Buttons */}
        <div className="form-group">
          <button type="button" className="btn btn-primary login-btn w-100">
            Suivant
          </button>
        </div>
      </form>
    );
  }
}

export default DemanderMesIdentifiantsForm;
